import { inject } from '@angular/core';
import { BrandService } from '../../services/brand-config.service';
import { PlatformService } from './platform.service';

/**
 * Whether this surface carries the daily loop (home, tools, a tool, the daily
 * check-in, the results "Your tools" panel). Surface split (Danna 25.09) moved
 * it into the Markable app; Peritale has no app, so its web keeps the loop
 * (Danna 27.09). Call in an injection context (field initializer or guard).
 */
export function hasDailyLoop(): boolean {
  return inject(PlatformService).isNative || !inject(BrandService).isMarkableHost;
}

/**
 * The daily loop is on this surface only because there is no app for this
 * brand (Peritale web): copy that says "continue in the app" must point to
 * the web home/tools instead (Danna 27.09).
 */
export function isWebDailyLoop(): boolean {
  return !inject(PlatformService).isNative && !inject(BrandService).isMarkableHost;
}
